var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"app-image",class:{ 'blur-image': _vm.loading },style:(_vm.style),attrs:{"src":_vm.urlLowQuality,"data-src":_vm.url,"data-srcset":`${_vm.url} 2x`,"alt":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }